import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { AuthProvider } from './auth.jsx';
import { LangProvider } from './i18n.jsx';
import { AvisosProvider } from './avisos.jsx';
import Salvavidas from './components/Salvavidas.jsx';
import './styles.css';

/*
 * `Salvavidas` va POR FUERA de todos los proveedores, a proposito: si lo que se
 * cae es el de idioma o el de sesion, un limite de error metido dentro se caeria
 * con ellos y volveriamos a la pantalla en blanco. Fuera, siempre queda alguien
 * que pueda pintar el aviso y el boton de recargar.
 */
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Salvavidas>
      <LangProvider>
        <AuthProvider>
          <AvisosProvider>
            <App />
          </AvisosProvider>
        </AuthProvider>
      </LangProvider>
    </Salvavidas>
  </StrictMode>
);
